import styled from 'styled-components';

import { colors } from 'config/theme';
export const SidebarWrapper = styled.div<{ expanded: boolean }>`
  padding: 1em 0.5em 1em 0;
  padding-left: ${(props) => !props.expanded && '0'};
  padding-right: ${(props) => !props.expanded && '0'};
  border-right: 2px solid ${colors.lightGray};
  min-width: ${(props) => (props.expanded ? '300px' : 'max-content')};
  max-width: ${(props) => (props.expanded ? '300px' : 'max-content')};

  header {
    padding-right: ${(props) => (props.expanded ? '0.5em' : '0')};
    align-items: center;
    color: #263238;
    display: flex;
    justify-content: ${(props) => (props.expanded ? 'flex-end' : 'center')};
  }

  hr {
    margin: ${(props) => (props.expanded ? '1em' : '1em 0.5em')};
    &:last-of-type {
      visibility: ${(props) => !props.expanded && 'hidden'};
    }
  }

  .MuiListItemIcon-root {
    min-width: unset;
  }

  ul {
    margin-top: 0.75em;
    li:first-child {
      height: 3em;
      h5 {
        margin-left: 0.5em;
      }
    }
  }

  .MuiListItemButton-root {
    background-color: ${(props) => !props.expanded && 'inherit'};
  }

  .MuiButtonBase-root {
  }

  .Mui-selected,
  .Mui-selected:hover {
    background-color: ${colors.lightestGray};
  }
`;
